import type { CommandHandler } from '../types';

export const setFieldValueCommandHandler: CommandHandler = async (command, context) => {
  const keys = Array.from(context.selectedRows ?? []);
  if (keys.length === 0 || keys.some((key) => !key || key.startsWith('temp_'))) {
    return { success: false, error: 'Select saved records to update.' };
  }
  if (!context.requestConfirmation || !context.updateBatchRows) {
    return { success: false, error: 'Batch update is not available.' };
  }

  let settings: { field?: unknown; value?: unknown };
  try {
    settings = JSON.parse(command.settings ?? '') as typeof settings;
  } catch {
    return { success: false, error: 'Batch command settings are invalid.' };
  }
  if (
    typeof settings?.field !== 'string' ||
    !settings.field.trim() ||
    typeof settings.value !== 'string'
  ) {
    return { success: false, error: 'Batch command settings are invalid.' };
  }

  const confirmed = await context.requestConfirmation(
    `${command.caption || 'Update'} ${keys.length} selected record${keys.length === 1 ? '' : 's'}?`
  );
  if (!confirmed) return { success: false };

  try {
    await context.updateBatchRows({
      nodeKey: context.metadata.contentKey,
      keys,
      fields: [{ FieldName: settings.field, StringValue: settings.value }],
    });
    context.clearSelection?.();
    return { success: true, shouldRefresh: true, message: `${keys.length} records updated.` };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to update selected records.',
    };
  }
};
